import 'whatwg-fetch';
import { notification, message } from 'antd';
import { stringify } from 'qs';
import { redirectToURL } from 'utils';

class Functor {
    constructor(value) {
        this.value = value;
    }
    map(fn, ...rest) {
        return new Functor(fn(this.value, ...rest));
    }
}

const setHeaders = options => {
    return {
        ...options,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
        },
    };
};

const formatData = ({ method, data, ...rest }) => {
    let res = {
        ...rest,
        method,
    };
    if (/post/i.test(method)) {
        res.body = JSON.stringify(data);
    }
    return res;
};

async function requestDataProcess(url, options) {
    let newUrl = url;
    if (/get/i.test(options.method)) {
        newUrl =
            newUrl +
            '?' +
            stringify(options.data) +
            (stringify(options.data) === '' ? '' : '&') +
            '_random=' +
            Date.now();
    }
    const newOptions = new Functor(options).map(formatData).map(setHeaders).value;

    const result = await fetch(`${newUrl}`, newOptions).then(async response => {
        if (response.status >= 200 && response.status < 300) {
            const responseJSON = await response.json();
            const { errcode, code: code = errcode, errmsg, msg, message: text = errmsg || msg } = responseJSON;
            switch (code) {
                case 0:
                case '0':
                    return responseJSON;
                case 801:
                    return redirectToURL(responseJSON.data);
                default:
                    message.error(text);
                    return responseJSON;
            }
        }
        notification.error({
            message: `请求错误 ${response.status}：${url}`,
            description: response.statusText,
        });
        return { code: '-1', message: '请求错误' };
    });
    return result;
}

/**
 * options {method, data, headers}
 */
export default async function request(url, options) {
    return requestDataProcess(url, options);
}
